export interface FiservApiErrorResponse {
    message: string,
    errorcode: string | number
}

function escapeHtml(text: string) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export function getFiservErrorMessage(errorResponse?: FiservApiErrorResponse, isCard: boolean = false) {
    if (!errorResponse || !errorResponse.message) {
        return 'Confirm your payment details are correct and try a different browser or device if the problem continues.';
    }

    if (isCard && errorResponse.message === 'Data too short') {
        return 'Card number is too short';
    }

    return escapeHtml(errorResponse.message);
}

export function createFiservApiErrorResponse(obj?: FiservApiErrorResponse | any) {
    const result = <FiservApiErrorResponse>{
        message: '',
        errorcode: ''
    };

    if (obj) {
        Object.assign(result, obj);
    }

    return result;
}
